import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import * as moment from 'moment';
import { Button } from '@progress/kendo-react-buttons';
import { fetchApi, JsonResponse } from '../../services/api';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { Input } from '@progress/kendo-react-inputs';
const DocumentTitle = require('react-document-title');

type BillingPeriodProps = RouteComponentProps<{
    periodId: string
}>

type State = {
    isLoading: boolean;
    Validation: boolean;

    period: BillingPeriodData|undefined;
}

type BillingPeriodData = {
    BillingPeriodID: number;
    Name: string;
    StartDate: Date;
    EndDate: Date;
}

class BillingPeriod extends React.Component<BillingPeriodProps, State> {
    constructor(props: BillingPeriodProps) {
        super(props);

        this.state = {
            isLoading: true,
            Validation: false,
            period: undefined,
        }

        this.save = this.save.bind(this);
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        let periodId = parseInt(this.props.match.params.periodId) || 0;
        this.requestBillingPeriod(periodId);
    }

    public componentWillReceiveProps(nextProps: BillingPeriodProps) {
        // This method runs when incoming props (e.g., route params) change
        let periodId = parseInt(nextProps.match.params.periodId) || 0;

        if (this.state.period && this.state.period.BillingPeriodID != periodId) {
            this.requestBillingPeriod(periodId);
        }
    }

    public render() {
        return <React.Fragment>
            {this.state.period &&
                <div className="k-form">
                    <DocumentTitle title={this.state.period.Name || "Billing Period"} />
                    <h5>{this.state.period.BillingPeriodID === 0 ? 'Create Next' : 'Update'} Billing Period</h5>
                    <label className="k-form-field">
                        <span>Name</span>
                        <Input
                            value={this.state.period.Name}
                            onChange={(e) => this.updateState({ Name: e.target.value })}
                        />
                    </label>

                    <label className="k-form-field">
                        <span>Start Date</span>
                        <DatePicker
                            format="MM/dd/yyyy"
                            formatPlaceholder="formatPattern"
                            value={this.state.period.StartDate}
                            onChange={(e) => this.updateState({ StartDate: e.value })}
                        />
                    </label>

                    <label className="k-form-field">
                        <span>End Date</span>
                        <DatePicker
                            format="MM/dd/yyyy"
                            formatPlaceholder="formatPattern"
                            value={this.state.period.EndDate}
                            onChange={(e) => this.updateState({ EndDate: e.value })}
                        />
                    </label>

                    <br />

                    <Button onClick={this.save} primary>{this.state.period.BillingPeriodID === 0 ? 'Create' : 'Update'}</Button>
                </div>
            }
        </React.Fragment>;
    }

    private updateState(value: Partial<BillingPeriodData>) {
        const period = Object.assign({}, this.state.period, value);
        this.setState({ period });
    }

    private requestBillingPeriod(periodId: number) {
        this.setState({ isLoading: true });
        if (periodId === 0) {
            const data = {
                FacilityID: localStorage.getItem("FACILITY_ID")
            };
            fetchApi(`api/Billing/GetCreateBillingPeriod`, data, 'POST')
                .then((response: { StartDate: Date }) => {
                    const period = {
                        BillingPeriodID: 0,
                        Name: moment(response.StartDate).format("MMMM YYYY"),
                        StartDate: moment(response.StartDate).toDate(),
                        EndDate: moment(response.StartDate).add(1, 'month').subtract(1, 'day').toDate(),
                    } as BillingPeriodData;
                    this.setState({ period });
                }).finally(() => {
                    this.setState({ isLoading: false });
                });
        } else {
            const data = {
                BillingPeriodID: periodId
            };
            fetchApi(`api/Billing/GetBillingPeriod`, data, 'POST')
                .then((response: BillingPeriodData) => {
                    response.StartDate = moment.utc(response.StartDate).toDate();
                    response.EndDate = moment.utc(response.EndDate).subtract(1, 'day').toDate();
                    this.setState({ period: response });
                }).finally(() => {
                    this.setState({ isLoading: false });
                });
        }
    }

    private save() {
        this.setState({ isLoading: true, Validation: true});
        if (this.state.period.BillingPeriodID === 0) {
            const data = {
                FacilityID: localStorage.getItem("FACILITY_ID"),
                Name: this.state.period.Name,
                StartDate: moment(this.state.period.StartDate).utc().toDate(),
                EndDate: moment(this.state.period.EndDate).add(1, 'day').startOf('day').utc().toDate()
            }
            fetchApi(`api/Billing/CreateBillingPeriod/`, data, 'POST')
                .then((response: JsonResponse) => {
                    if (response.Success) {
                        this.props.history.push("/invoices/periods");
                    } else {
                        alert(response.ErrorMessage);
                    }
                }).finally(() => {
                    this.setState({ isLoading: false });
                });
        } else {
            const data = {
                BillingPeriodID: this.state.period.BillingPeriodID,
                Name: this.state.period.Name,
                StartDate: moment(this.state.period.StartDate).utc().toDate(),
                EndDate: moment(this.state.period.EndDate).add(1, 'day').startOf('day').utc().toDate()
            }
            fetchApi(`api/Billing/UpdateBillingPeriod/`, data, 'POST')
                .then((response: JsonResponse) => {
                    if (response.Success) {
                        this.props.history.push("/invoices/periods");
                    } else {
                        alert(response.ErrorMessage);
                    }
                }).finally(() => {
                    this.setState({ isLoading: false });
                });
        }
    }
}

export default BillingPeriod;
